<---淘宝电商推广-->
<template>
  <div class="container">
    <img :src="currentCourse.imgBgUrl" alt="" class="img" />
    <div class="input-container">
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '一建建筑全科',
          id: 'BK202406230001',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs1_jianzhu_bg.jpg',
          promotedAccount: '中课电商-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: 'e4bb9ee8dd524d84b3bc11030714f16e',
              subjectid: '69e46917cfdf4fa1a103ce044b368051'
            }
          ]
        },
        {
          name: '一建市政全科',
          id: 'BK202406230002',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs1_shizheng_bg.jpg',
          promotedAccount: '中课电商-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: '547f3d59730243188e28e2ce963f330a',
              subjectid: '7b44758158d24726ab0a3a627c1e4c84'
            }
          ]
        },
        {
          name: '一建机电全科',
          id: 'BK202406230003',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs1_jidian_bg.jpg',
          promotedAccount: '中课电商-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '0e3d8e27c663449ba6b08e8a304b1126',
              subjectid: '8c0126ad336c470ab786631fd3a0b64e'
            }
          ]
        },
        {
          name: '一建公路全科',
          id: 'BK202406230004',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs1_gonglu_bg.jpg',
          promotedAccount: '中课电商-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'e4b89fba482f4c60a1d4741769416103',
              subjectid: 'fb34520de9d046ee93a974f0b1e2642b'
            }
          ]
        },
        {
          name: '一建水利全科',
          id: 'BK202406230005',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs1_shuili_bg.jpg',
          promotedAccount: '中课电商-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '2afcc6d80c9a48a7ac171ad4e9591e24',
              subjectid: '7a57c2fdc74b465aa3810a456958c781'
            }
          ]
        },
        {
          name: '二建建筑全科',
          id: 'BK202406230006',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs2_jianzhu_bg.jpg',
          promotedAccount: '中课电商-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: 'e54f38a61d1e4bb69600f51646a520c2',
              subjectid: '3bdfeeff79834aa08cf1f34f68143cbd'
            }
          ]
        },
        {
          name: '二建市政全科',
          id: 'BK202406230007',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs2_shizheng_bg.jpg',
          promotedAccount: '中课电商-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: '09d3e4727267425291909374866407cb',
              subjectid: '704086d0180f439d882cb671c232e9ce'
            }
          ]
        },
        {
          name: '二建机电全科',
          id: 'BK202406230008',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs2_jidian_bg.jpg',
          promotedAccount: '中课电商-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '660a40b0128d4f65835f3b3853a909e5',
              subjectid: '0137751bebf94548a39f4c78ab8caa20'
            }
          ]
        },
        {
          name: '二建公路全科',
          id: 'BK202406230009',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs2_gonglu_bg.jpg',
          promotedAccount: '中课电商-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'bcdd4af1dda74e9d8b407d0073e721dc',
              subjectid: '9f6a0901dd8746d3ac6ec25669f05482'
            }
          ]
        },
        {
          name: '二建水利全科',
          id: 'BK202406230010',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/jzs2_shuili_bg.jpg',
          promotedAccount: '中课电商-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '36bc527d1c314eb4a664fec0e17b0081',
              subjectid: 'dd28111117f141afb53192d079fa2bc0'
            }
          ]
        },
        {
          name: '注安建筑施工安全全科',
          id: 'BK202406230011',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_jianzhu_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全全科',
              worthid: '7d9bc614f59541fcb10fe51e7acbd487',
              subjectid: '6d50bafdbf2b40ffa4eb85bb861d4ace'
            }
          ]
        },
        {
          name: '注安化工安全全科',
          id: 'BK202406230012',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_huagong_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全全科',
              worthid: '9f795b523f2c46b391f9718d004552be',
              subjectid: 'a7c4f50d5ce94eef9ee8880ca2f4cc71'
            }
          ]
        },
        {
          name: '注安其他安全全科',
          id: 'BK202406230013',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_qita_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全全科',
              worthid: '924b510e5a7244afabd2192a991c3439',
              subjectid: '5382d9e80806476999073b88290cac58'
            }
          ]
        },
        {
          name: '注安煤矿安全全科',
          id: 'BK202406230014',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_meikuang_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '煤矿安全全科',
              worthid: 'c33991d6611f4e5baeff1b081ab5b94e',
              subjectid: '63a0aa33686b4a56b4477f8696f716e8'
            }
          ]
        },
        {
          name: '注安金属非金属全科',
          id: 'BK202406230015',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_jinshu_feijinshu_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属非金属全科',
              worthid: 'f779856859374c58bc2e86c90ba08e00',
              subjectid: 'e0eed484583c49a2817a1b9cd225784b'
            }
          ]
        },
        {
          name: '注安金属冶炼全科',
          id: 'BK202406230016',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_jinshuyelian_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属冶炼全科',
              worthid: '266be3a8e1d04b0da0d52089cdbe1790',
              subjectid: '89f5ce69ccf04c529ac91ed959c695e9'
            }
          ]
        },
        {
          name: '注安道路运输安全全科',
          id: 'BK202406230017',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tb/aqs_daolu_bg.jpg',
          promotedAccount: '中课电商-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '道路运输安全全科',
              worthid: '5e82bf9768fb4697ae329e715631c2e1',
              subjectid: '0d9d3c77fe5b4aabb3c2d8d7da814279'
            }
          ]
        }
      ],
      id: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '图书',
        promotedAccount: this.currentCourse.promotedAccount
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
      })
    }
  },
  created() {
    this.id = this.$route.params.id
    this.currentCourse = this.list.find(item => item.id == this.id)
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 53vw;
    width: 100%;
    padding: 173vw 9.5vw 0;
    z-index: 1;

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      input {
        flex: 1;
        border: none;
        outline: none;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        font-size: 12px;
        height: 41px;
        box-shadow: none;
        background: rgb(243, 244, 246);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        width: 99px;
        height: 30px;
        border-radius: 5px;
        background: rgb(27, 102, 203);
        span {
          color: #fff;
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      margin: 21px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 100%;
      width: 90%;
      background: none;
    }
  }
}
</style>
